export default "__VITE_ASSET__357bb1a2__"